import { render } from "./Footer.vue?vue&type=template&id=175d6a68"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\Trinity_Projects\\cesp_skuuni_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__